// === CENTRAL PRODUCT ICON REGISTRY ===
// One map from product id to its icon component — the single source for every
// surface that renders a product icon (selection cards, mobile chips, the
// selection summary card). Same pattern as registry.ts (SectionIcon): register
// here once, consumers never import icon libraries directly.
//
// Mix: phosphor duotone where the set has a correct glyph, hand-drawn duotone
// (customProductIcons) where it does not. Every entry satisfies phosphor's
// IconProps contract, so consumers treat all entries identically.

import { Airplane, Armchair, Bicycle, Boat, Car, Heartbeat, House, Scales, ShieldCheck } from 'phosphor-react';
import { CamperVanIcon, CaravanIcon, MotorcycleIcon, ScooterIcon } from './customProductIcons';

export type ProductIconId =
  | 'personenauto'
  | 'motor'
  | 'bromfiets'
  | 'fiets'
  | 'woonhuis'
  | 'inboedel'
  | 'aansprakelijkheid'
  | 'rechtsbijstand'
  | 'ongevallen'
  | 'doorlopendereis'
  | 'caravan'
  | 'camper'
  | 'boot';

export const productIcons: Record<ProductIconId, typeof Car> = {
  personenauto: Car,
  motor: MotorcycleIcon,
  bromfiets: ScooterIcon,
  fiets: Bicycle,
  woonhuis: House,
  inboedel: Armchair,
  aansprakelijkheid: ShieldCheck,
  rechtsbijstand: Scales,
  ongevallen: Heartbeat,
  doorlopendereis: Airplane,
  caravan: CaravanIcon,
  camper: CamperVanIcon,
  boot: Boat,
};
